import { updateProfile } from "firebase/auth";

import {auth} from './firebase';
// import {parseDocs} from '@/lib/parse-docs';
export const currentUser = () => auth.currentUser;
export const updateUserProfile = async (profile) => await updateProfile(currentUser(), profile);

